<template>
  <div id="app" class="app">
    <transition name="component-fade" mode="out-in">
    <!-- <WelcomeScreen v-if="step == 'welcome'" @next-step="nextStep" /> -->
    <!-- <VideoScreen v-if="step == 'video'" @next-step="nextStep" /> -->
    <QuizScreen
      v-if="step == 'quiz'"
      :questionIndex="questionIndex"
      :progress="answers.length && progress()"
      :questionType="questions[questionIndex].questionType"
      :questionImageA="questions[questionIndex].questionImageA"
      :questionImageB="questions[questionIndex].questionImageB"
      :questionImage="questions[questionIndex].questionImage"
      :answerImage="questions[questionIndex].answerImage"
      :correctAnswer="correctAnswer()"
      :score="score"
      :level="level"
      :levelProgress="levelProgress"
      @next-step="nextStep"
      @next-question="nextQuestion"
      @answer="storeAnswer"
    />
    <ResultScreen
      v-if="step == 'result'"
      :level="level"
      :levelProgress="levelProgress"
      :score="score"
      :total="questions.length"
      @restart="restart"
    />
    </transition>
  </div>
</template>

<script>
// import WelcomeScreen from "./components/WelcomeScreen.vue";
// import VideoScreen from "./components/VideoScreen.vue";
import QuizScreen from "./components/QuizScreen.vue";
import ResultScreen from "./components/ResultScreen.vue";

// import { questionsYes, questionsNo } from "./data/questions";
import questionsYes from './data/questionsYes.json'
import questionsNo from './data/questionsNo.json'
import questionAB from './data/questionAB.json'
import questionsD from './data/questionsD.json'

export default {
  name: "App",
  metaInfo() {
    return {
      title: this.$t('general.title'),
      description: this.$t('general.description'),
      meta: [
                {   'name':'og:title',
                    'content': this.$t('result.share.title'),
                },
                {   'name':'metatitle',
                    'content': this.$t('general.title'),
                },
                {   'name':'og:description',
                    'content': this.$t('result.share.description'),
                },
                {   'name':'description',
                    'content': this.$t('general.description'),
                },
                {   'name':'og:image',
                    'content': document.location.href + 'images/' + this.$i18n.locale + '/stop-melanoma-preview.png',
                }
            ]
    }
  },
  components: {
    // WelcomeScreen,
    // VideoScreen,
    QuizScreen,
    ResultScreen,
  },
  data() {
    return {
      step: "quiz",
      questionIndex: 0,
      questions: [],
      answers: [],
      score: 0,
      level: 'rookie',
      levelProgress: 0
    };
  },
  mounted() {
    this.shuffleQuestions();
  },
  methods: {
    shuffleQuestions() {
      // console.log("shuffleQuestions");

      //Clean questions array
      this.questions = [];
      // console.log("Nb of questions: ", this.questions.length);
      // console.log("questions: ", this.questions);

      // Always 1 question A/B
      this.questions.push(questionAB[0]);
      // console.log("Nb of questions: ", this.questions.length);
      // console.log("questions: ", this.questions);

      // Always 2 questions D
      this.questions = this.questions.concat(this.getMultipleRandom(questionsD, 2));
      // console.log("Nb of questions: ", this.questions.length);
      // console.log("questions: ", this.questions);

      // 3 Yes questions 
      this.questions = this.questions.concat(this.getMultipleRandom(questionsYes, 3));
      // console.log("Nb of questions: ", this.questions.length);
      // console.log("questions: ", this.questions);

      // 2 No Question
      this.questions = this.questions.concat(this.getMultipleRandom(questionsNo, 2));
      // console.log("Nb of questions: ", this.questions.length);
      // console.log("questions: ", this.questions);

      //Shuffle question array
      this.questions = this.shuffleArray(this.questions);
    },
    nextStep() {
      switch (this.step) {
        // case "welcome":
        //   this.step = "video";
        //   break;
        // case "video":
        //   this.step = "quiz";
        //   break;
        case "quiz":
          this.step = "result";
          break;
      }
    },
    restart() {
      this.answers = [];
      this.questionIndex = 0;
      this.score = 0;
      this.level = 'rookie';
      this.levelProgress = 0;
      this.step = "quiz";
      this.shuffleQuestions();
    },
    nextQuestion() {
      if (this.questionIndex === this.questions.length - 1) {
        this.nextStep();
      } else {
        this.questionIndex++;
      }
    },
    storeAnswer(index, value) {
      console.log("storeAnswer: ", value);
      if (index === this.questionIndex) {
        this.$set(this.answers, this.questionIndex, value);
        console.log("answers: ", this.answers);

        if (this.correctAnswer()) {
          this.score++;
          // Update level
          if (this.score >= 8) {
            this.level = 'expert'; 
          } else if (this.score >= 4) {
            this.level = 'advanced';
          } else {
            this.level = 'rookie';
          }
          // Update levelProgress
          this.levelProgress = Math.round(
            (this.score / this.questions.length) * 100
          );
        }
      } else {
        console.log("wrong question index!");
      }
    },
    progress() {
      return Math.round((this.answers.length / this.questions.length) * 100);
    },
    correctAnswer() {
      return (
        this.answers[this.questionIndex] ===
        this.questions[this.questionIndex].answer
      );
    },
    getMultipleRandom(arr, num) {
      const shuffled = [...arr].sort(() => 0.5 - Math.random());

      return shuffled.slice(0, num);
    },
    shuffleArray(arr) {
      return arr.sort(() => Math.random() - 0.5);
    }
  },
};
</script>

<style lang="scss">

:root {
  --clr-gray-100: #e6e8f0;
  --clr-gray-200: #dbdbdb;
  --clr-gray-800: #4E5055;
  --clr-yellow: #ffcc00;
  --clr-yellow-hover: #FCDD61;
  --clr-green: #19d893;
  --clr-red: #ff5050;
  --clr-brown: #C27E51;
  --clr-brown-hover: #E59662;
}

html, body {
  font-family: "Metropolis", "Montserrat", "Raleway", sans-serif;
}

#app {
  font-family: "Metropolis", "Montserrat", "Raleway", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--clr-gray-800);

  @media (min-width: 768px) {
    height: 100vh;
  }
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 5px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  text-transform: uppercase;
  padding: 0.75rem 1.5rem;

  &:disabled {
    background-color: var(--clr-gray-200);
  }

  > * + * {
    margin-left: 1rem;
  }
}

.button--yellow {
  background-color: var(--clr-yellow);
  color: #fff;
  border-radius: 5px;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  padding: 0.75rem 1.5rem;

  &:disabled {
    background-color: var(--clr-gray-200);
  }

  &:hover:not([disabled]) {
    background-color: var(--clr-yellow-hover);
  }
}

.button--brown {
  background-color: var(--clr-brown);
  color: #fff;
  border-radius: 5px;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  padding: 0.75rem 1.5rem;

  &:disabled {
    background-color: var(--clr-gray-200);
  }

  &:hover:not([disabled]) {
    background-color: var(--clr-brown-hover);
  }
}

.post-it {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: var(--clr-yellow);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  padding: 0.75rem 1.5rem;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -10px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent var(--clr-yellow) transparent;
  }
}
</style>
